import { X } from 'lucide-react';

const GROUPS: { title: string; items: [string, string][] }[] = [
  {
    title: 'Transport',
    items: [
      ['Space', 'Play / stop'],
      ['⌘Z / ⇧⌘Z', 'Undo / redo'],
      ['1 – 8', 'Select track'],
      ['[ / ]', 'Previous / next view'],
    ],
  },
  {
    title: 'Pattern grid',
    items: [
      ['Click', 'Select step and audition it'],
      ['Drag', 'Reorder steps'],
      ['Alt + drag', 'Copy a slice onto another step'],
      ['Shift / ⌘ click', 'Extend or toggle the selection'],
      ['Right click', 'Reverse the step'],
      ['Double click', 'Mute the step'],
    ],
  },
  {
    title: 'Selected steps',
    items: [
      ['R', 'Toggle reverse'],
      ['M', 'Toggle mute'],
      ['X', 'Clear to a rest'],
      ['D', 'Duplicate'],
      ['Backspace', 'Delete'],
      ['← / →', 'Move step earlier / later'],
      ['↑ / ↓', 'Next / previous slice'],
      ['⇧ ↑ / ⇧ ↓', 'Pitch up / down a semitone'],
    ],
  },
];

export function Shortcuts({ onClose }: { onClose: () => void }) {
  return (
    <div className="fade-in fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4" onClick={onClose}>
      <div className="panel zoom-in w-[34rem] p-4" onClick={(e) => e.stopPropagation()}>
        <div className="mb-3 flex items-center justify-between">
          <h2 className="display text-sm">Keyboard shortcuts</h2>
          <button className="btn btn-icon" onClick={onClose}>
            <X size={13} />
          </button>
        </div>
        <div className="grid grid-cols-2 gap-x-6 gap-y-4">
          {GROUPS.map((g) => (
            <div key={g.title}>
              <div className="label mb-1.5">{g.title}</div>
              <dl className="space-y-1">
                {g.items.map(([k, v]) => (
                  <div key={k} className="flex items-baseline gap-2">
                    <dt className="mono w-24 shrink-0 text-[10px] text-volt-400">{k}</dt>
                    <dd className="text-[11px] text-ink-300">{v}</dd>
                  </div>
                ))}
              </dl>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
